import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
export function TestimonialsSection() {
  return <section className="w-full bg-sand py-10 sm:py-12" aria-labelledby="testimonials-heading" data-id="element-203" data-mp="20qnn9oe9sfo2">
      <div className="mx-auto max-w-6xl px-6" data-id="element-204" data-mp="1mzith2xl2hln">
        <div className="mx-auto max-w-2xl text-center" data-id="element-205" data-mp="1r1dvyar93110">
          <p className="eyebrow text-terracotta-deep" data-id="element-206" data-mp="1qzt1sm8ulk3o">
            Real teachers. Real relief.
          </p>
          <h2 id="testimonials-heading" className="mt-5 font-display text-[2rem] leading-[1.12] text-ink sm:text-4xl" data-id="element-207" data-mp="1d3xp4y51l58q">
            What art teachers are saying
          </h2>
        </div>

        <ul className="mt-11 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-208" data-mp="142zfo0bu45ir">
          {testimonials.map(testimonial => <li key={testimonial.author + testimonial.context} className="flex h-full flex-col rounded-3xl border border-line bg-shell p-6" data-id="element-209" data-mp="184ugl3pusgw0">
              <div className="flex gap-1" aria-label="Rated 5 out of 5" data-id="element-210" data-mp="32haumqow4zbf">
                {Array.from({
              length: 5
            }).map((_, index) => <StarIcon key={index} className="h-3.5 w-3.5 fill-gold text-gold" aria-hidden="true" data-id="element-211" data-mp="2uzrj73d6vfl4" data-mpi={index} />)}
              </div>

              <blockquote className="mt-4 font-sans text-[0.9rem] leading-relaxed text-ink/85" data-id="element-212" data-mp="2q0n8u9ej3bt7">
                “{testimonial.quote}”
              </blockquote>

              <footer className="mt-auto pt-6" data-id="element-213" data-mp="2ztm2i5ovtsjo">
                <span className="block h-px w-8 bg-terracotta/50" aria-hidden="true" data-id="element-214" data-mp="2c2q8r30v8n9s" />
                <span className="mt-4 block font-display text-base text-ink" data-id="element-215" data-mp="2c4jiwsaotpmj">
                  {testimonial.author}
                </span>
                <span className="mt-0.5 block font-sans text-xs text-stone" data-id="element-216" data-mp="2m161fafjk4le">
                  {testimonial.context}
                </span>
              </footer>
            </li>)}
        </ul>
      </div>
    </section>;
}